import React from "react";

import { HeaderContainer } from "../../components/Layout/HeaderContainer/HeaderContainer";
import { PageContainer } from "../../components/Layout/PageContainer/PageContainer";

import { MenuButton } from "../../components/Shared/Buttons/MenuButton";
import { PageTitle } from "../../components/Shared/Headings/PageTitle";

import { AccessHeaderLogo } from "../../components/Shared/Buttons/AccessHeaderLogo";
import { ComingSoon } from "../../components/Shared/Other/ComingSoon/ComingSoon";

export const HomePage = () => {
  return (
    <PageContainer
      header={{
        content: (
          <HeaderContainer
            start={<MenuButton />}
            middle={<PageTitle title="Dashboard" />}
            end={<AccessHeaderLogo />}
            featureSentimentName="Dashboard"
          />
        )
      }}
      main={{
        content: <ComingSoon />
      }}
    />
  );
};
